module.exports = __webpack_public_path__ + "assets/media/google-logo.fd168f70.svg";


//////////////////
// WEBPACK FOOTER
// ./src/layouts/SignupChoiceCard/google-logo.svg
// module id = 3193
// module chunks = 0